export default "__VITE_ASSET__2122dd61__"